import $ from 'jquery';
import TemplateView from 'picnic/core/views/Template';
import Template from './Button.html';


var
	CLASS_OPEN = 'is-open'
;


class View extends TemplateView {

	events() {
		return {
			'click .more': '_onClick'
		};
	}

	get template() {
		return Template;
	}

	_onClick(e) {
		const $el = $(e.currentTarget);
		e.preventDefault();
		this.$el.toggleClass(CLASS_OPEN);
		$el.text((this.$el.hasClass(CLASS_OPEN) ? $el.data('less') : $el.data('more')));
	}
}

export default View;
